import {
  BibliographyClass,
  CollectionFlag,
  Prefix,
  PublishNewArrivalMagazine,
  SearchType
} from '@/types'
import { exists } from '@/api'

export interface NewArrivalMagazine {
  id: number
  type: SearchType
  displayClass: string
  displayTitle: string
  displaySubtitle: string
  displayAuthor: string
  displayPublisher: string
  displayPublished: string
  displaySize: string
  sortTitle: string
  sortNumber: string
  sortKana: string
  sortAuthor: string
  sortPublisher: string
  sortSubtitle: string
  sortPublished: string
  marcType: string
  marcNo: string
  collectionFlag: CollectionFlag
  publishNewArrivalMagazine: PublishNewArrivalMagazine
  revision: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
}

export function NewArrivalMagazineFromJSON(json: any): NewArrivalMagazine {
  const defaultValue: NewArrivalMagazine = defaultNewArrivalMagazine()

  return {
    id: exists(json, 'id') ? json.id : defaultValue.id,
    type: exists(json, 'type') ? json.type : defaultValue.type,
    displayClass: exists(json, 'display_class')
      ? json.display_class
      : defaultValue.displayClass,
    displayTitle: exists(json, 'display_title')
      ? json.display_title
      : defaultValue.displayTitle,
    displaySubtitle: exists(json, 'display_subtitle')
      ? json.display_subtitle
      : defaultValue.displaySubtitle,
    displayAuthor: exists(json, 'display_author')
      ? json.display_author
      : defaultValue.displayAuthor,
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : defaultValue.displayPublisher,
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : defaultValue.displayPublished,
    displaySize: exists(json, 'display_size')
      ? json.display_size
      : defaultValue.displaySize,
    sortTitle: exists(json, 'sort_title')
      ? json.sort_title
      : defaultValue.sortTitle,
    sortNumber: exists(json, 'sort_number')
      ? json.sort_number
      : defaultValue.sortNumber,
    sortKana: exists(json, 'sort_kana')
      ? json.sort_kana
      : defaultValue.sortKana,
    sortAuthor: exists(json, 'sort_author')
      ? json.sort_author
      : defaultValue.sortAuthor,
    sortPublisher: exists(json, 'sort_publisher')
      ? json.sort_publisher
      : defaultValue.sortPublisher,
    sortSubtitle: exists(json, 'sort_subtitle')
      ? json.sort_subtitle
      : defaultValue.sortSubtitle,
    sortPublished: exists(json, 'sort_published')
      ? json.sort_published
      : defaultValue.sortPublished,
    marcType: exists(json, 'marc_type')
      ? json.marc_type
      : defaultValue.marcType,
    marcNo: exists(json, 'marc_no') ? json.marc_no : defaultValue.marcNo,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : defaultValue.collectionFlag,
    publishNewArrivalMagazine: exists(json, 'publish_new_arrival_magazine')
      ? json.publish_new_arrival_magazine
      : defaultValue.publishNewArrivalMagazine,
    revision: exists(json, 'revision') ? json.revision : defaultValue.revision,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : defaultValue.bibliographyClass,
    prefix: exists(json, 'prefix') ? json.prefix : defaultValue.prefix
  }
}

export const defaultNewArrivalMagazine = (): NewArrivalMagazine => ({
  id: 0,
  type: SearchType.Book,
  displayClass: '',
  displayTitle: '',
  displaySubtitle: '',
  displayAuthor: '',
  displayPublisher: '',
  displayPublished: '',
  displaySize: '',
  sortTitle: '',
  sortNumber: '',
  sortKana: '',
  sortAuthor: '',
  sortPublisher: '',
  sortSubtitle: '',
  sortPublished: '',
  marcType: '',
  marcNo: '',
  collectionFlag: CollectionFlag.NotCollection,
  publishNewArrivalMagazine: PublishNewArrivalMagazine.Private,
  revision: 0,
  bibliographyClass: BibliographyClass.Set,
  prefix: Prefix.Set
})
